<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model" *transloco="let tr; prefix: 'organizations'; scope: 'organizations'">
  <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.countryId')}}</nz-form-label>
          <nz-form-control>
            <hx-country-select formControlName="countryId"></hx-country-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.currency')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select enumName="Currency" [enumType]="Currency" formControlName="currency"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1_5">
        <nz-form-item>
          <nz-form-label>{{tr('form.epayOrgId')}}</nz-form-label>
          <nz-form-control>
            <hx-org-select [countryId]="form.controls.countryId.value" formControlName="epayOrgId"></hx-org-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1_5">
        <nz-form-item>
          <nz-form-label>{{tr('form.parentId')}}</nz-form-label>
          <nz-form-control>
            <hx-org-select [countryId]="form.controls.countryId.value" formControlName="parentId"></hx-org-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.paymentTypes')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select [hxMode]="'multiple'" enumName="PaymentType" [enumType]="PaymentType"
                            formControlName="paymentTypes"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.invoicePaymentTypes')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select [hxMode]="'multiple'" enumName="PaymentType" [enumType]="PaymentType"
                            formControlName="invoicePaymentTypes"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- info fields -->

    <nz-divider [nzDashed]="true" [nzText]="tr('form.orgDetails')" nzOrientation="left"></nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.postalIndex')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="postalIndex"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.legalAddress')}}</nz-form-label>
          <nz-form-control>
            <textarea rows="4" nz-input formControlName="legalAddress"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.uinLabel')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="uinName"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.uin')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="uin"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.taxType')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="taxType">
              <label nz-radio nzValue="FREE">Без НДС</label>
              <label nz-radio nzValue="VAT">12% НДС</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('form.taxSeries')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="taxSeries"/>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('form.taxNumber')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="taxNumber"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label
            [nzTooltipTitle]="tr('form.ofdVerifierInfo.tooltip')">{{tr('form.ofdVerifierInfo')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="ofdVerifierInfo"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.directorId')}}</nz-form-label>
          <nz-form-control>
            <hx-user-select formControlName="directorId"></hx-user-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label>{{tr('form.accountantId')}}</nz-form-label>
          <nz-form-control>
            <hx-user-select formControlName="accountantId"></hx-user-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label [nzTooltipTitle]="tr('form.stampFileId.tooltip')">{{tr('form.stampFileId')}}</nz-form-label>
          <nz-form-control>
            <nz-upload [nzAccept]="'.png'" [nzAction]="fileUploadUrl"
                       [(nzFileList)]="stampFiles"
                       [nzData]="dataFn"
                       [nzHeaders]="fileUploadHeadersFn"
                       (nzChange)="onStampFileChanged($event)">
              <button nz-button type="button"><i nz-icon nzType="upload"></i> {{'button.upload' | transloco}}</button>
            </nz-upload>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider [nzDashed]="true" [nzText]="tr('form.blank')" nzOrientation="left"></nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.paymentDestinationCode')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="paymentDestinationCode"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider [nzDashed]="true" [nzText]="tr('form.bankDetails')" nzOrientation="left"></nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col *ngFor="let bankAccount of bankAccounts; let ix = index">
        <div class="ant-card ant-card-bordered hx-card">
          <div class="ant-card-body">
            <div class="ant-card-meta">
              <div class="ant-card-meta-detail">
                <div class="ant-card-meta-title" [nz-tooltip]="bankAccount.bank?.name">{{ bankAccount.bank?.name }}</div>
                <div class="ant-card-meta-description">{{ bankAccount.iban }}</div>
                <div class="ant-card-meta-description">КБе: {{ bankAccount.beneficiaryCode }}</div>
                <nz-radio-group (ngModelChange)="setDefaultBankAccount(bankAccount.id)" [(ngModel)]="bankAccount.default" [ngModelOptions]="{standalone: true}">
                  <label nz-radio [nzValue]="true">{{tr('form.default')}}</label>
                </nz-radio-group>
              </div>
            </div>
            <div class="m--margin-left-10 ">
              <button type="button" nzType="primary" nz-button nz-popconfirm (click)="editBankAccounts(bankAccount)">
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </button>

              <button type="button" nzDanger nzType="default" nz-button nz-popconfirm
                      [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                      [nzCancelText]="'no1' | transloco"
                      (nzOnConfirm)="deleteBankAccount(bankAccount.id)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div nz-col class="cp_add-new-card">
        <button type="button" nzSize="large" nz-button nzType="dashed" (click)="isVisible.addBankAccount = true">
          <i nz-icon nzType="plus-circle" nzTheme="twotone"></i> {{tr('button.addBankAccount')}}
        </button>
      </div>
    </div>


    <nz-divider [nzDashed]="true" [nzText]="text" nzOrientation="left">
      <ng-template #text>
        {{tr('form.storeDirectors')}} <i nz-icon [nz-tooltip]="tr('form.storeDirectors.tooltip')"
                                         nzType="question-circle"></i>
      </ng-template>
    </nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col *ngFor="let storeDirector of storeDirectors; let ix = index">
        <div class="ant-card ant-card-bordered hx-card">
          <div class="ant-card-body">
            <div class="ant-card-meta">
              <div class="ant-card-meta-detail">
                <div class="ant-card-meta-title">{{ storeDirector.store.title | uiLabel }}</div>
                <div class="ant-card-meta-description">{{ storeDirector.user.fullname }}</div>
              </div>
            </div>
            <div>
              <button type="button" nzDanger nzType="default" nz-button nz-popconfirm
                      [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                      [nzCancelText]="'no1' | transloco"
                      (nzOnConfirm)="deleteStoreDirector(ix)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div nz-col class="cp_add-new-card">
        <button type="button" nzSize="large" nz-button nzType="dashed" (click)="isVisible.addStoreDirector = true">
          <i nz-icon nzType="plus-circle" nzTheme="twotone"></i> {{tr('button.addStoreDirector')}}
        </button>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco"
              nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button
                    nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model?.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>

  <nz-modal
    [(nzVisible)]="isVisible.addStoreDirector"
    [nzTitle]="tr('modal.addStoreDirector.title')"
    [nzOkText]="'button.addNew' | transloco"
    [nzCancelText]="'button.close' | transloco"
    (nzOnOk)="addDirector()"
    (nzOnCancel)="isVisible.addStoreDirector = false"
  >
    <ng-container *nzModalContent>
      <div class="hx-form ant-form-vertical">
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('modal.addStoreDirector.storeId')}}</nz-form-label>
              <nz-form-control>
                <hx-store-select [orgId]="model?.id" [(ngModel)]="storeId"></hx-store-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('modal.addStoreDirector.userId')}}</nz-form-label>
              <nz-form-control>
                <hx-user-select [storeId]="storeId" [(ngModel)]="userId"></hx-user-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
    </ng-container>
  </nz-modal>

  <nz-modal
    [(nzVisible)]="isVisible.addBankAccount"
    [nzTitle]="tr('modal.addBankAccount.title')"
    [nzOkText]="'button.save' | transloco"
    [nzCancelText]="'button.close' | transloco"
    (nzOnOk)="addBankAccount()"
    (nzOnCancel)="isVisible.addBankAccount = false"
  >
    <ng-container *nzModalContent>
      <div class="hx-form ant-form-vertical">
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('modal.addBankAccount.bankId')}}</nz-form-label>
              <nz-form-control>
                <hx-bank-select [(ngModel)]="bankAccountRequest.bankId"></hx-bank-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('modal.addBankAccount.iban')}}</nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="bankAccountRequest.iban"/>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('modal.addBankAccount.currency')}}</nz-form-label>
              <nz-form-control>
                <hx-enum-select enumName="Currency" [enumType]="Currency" [(ngModel)]="bankAccountRequest.currency"></hx-enum-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('modal.addBankAccount.beneficiaryCode')}}</nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="bankAccountRequest.beneficiaryCode"/>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
    </ng-container>
  </nz-modal>
</nz-skeleton>


